import { LangFields, LangProps } from '../types/Lang.types'

export class LangModel {
  private readonly fields?: LangFields
  constructor(props: LangProps) {
    this.fields = props.fields;
  }
}
